import React from 'react';
import './index.scss';
import styled from 'styled-components';
import { Button } from '@roo/roo';
import { useUserContext } from '../UserData';
import { Link, useHistory } from 'react-router-dom';
import arrow from '../../assets/images/arrow.svg'
import Dayjs from 'dayjs';

const Root = styled.div`
  width: 1200px;
  margin: auto;
`;

const TrendCard = () => {
  const { state } = useUserContext((t) => [t.articles]);
  const list = (state.articles || []).slice(0,3);

  return (
    <Root className='trend-list'>
      <div className='trend-list-title'>基金动态</div>
      {list.map((item) => {
        const { title, url, time } = item;
        let formatTime = Dayjs(time).format("YYYY[年]MM[月]DD[日]")
        return (
            <div key={title} className="list-item trend-card" onClick={()=>window.open(url, '_blank')}>
                <div className="time">{formatTime}</div>
                <div className="desc">
                  <span>{title}</span>
                  <img src={arrow}></img>
                </div>
            </div>
        );
      })}
      <Button className='trend-list-button' type="hollow" onClick={() => {
        location.href = '/trend#top';
      }}>了解更多</Button>
    </Root>
  );
};


export default TrendCard;